<script setup name="personCollection">
import { useTaxStore } from '@/store/modules/tax.js'
import add from './add.vue';
import {ElLoading, ElMessage, ElMessageBox} from 'element-plus'
import {getToken} from "@/utils/auth.js";
import {useOnResize} from "@/views/examCenter/tax/components/consolidatedIncome/components/oneResizeHandler.js";
const activeName = ref('within');
const taxStore = useTaxStore()
const route = useRoute();
const { personCollectionList,answer } = storeToRefs(taxStore);
const handleClick = (val) =>{
    console.log(val)
    if(val === 'outer'){
        ElMessage({
            message: '非实训主要涉及业务，不做功能操作',
            type: 'info',
        })
        activeName.value = 'within'
    }
}
const tableRef = ref(null)
const showAdd = ref(false);
const tableData = ref([...personCollectionList.value]);
const clearList = () =>{
    ElMessageBox.confirm(
    '确定要重做吗?',
    '信息',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        tableData.value = []
    })
    .catch(() => {

    })
}
//获取选中
const getSelectionRows = () =>{
    let rows = tableRef.value.getSelectionRows();
    console.log(rows)
    return rows
}
//报送中数据
const getReportList = () =>{
    const rows = getSelectionRows();
    let list = rows.filter(item => item.reportStatus == '报送中'|| item.reportStatus == '报送成功')
    return list
}
const confirmAdd = (val) =>{
    const index = tableData.value.findIndex(item => item.idNumber == val.idNumber);
    if(index>-1){
        return ElMessage({
            message: '人员已存在',
            type: 'warning',
        })
    }else{
        tableData.value.push({...val})
    }
}
const reportHandler = () =>{
    let row = getSelectionRows();
    if(row.length == 0){
        return ElMessage({
            message: '您还没有选中需要报送的人员',
            type: 'warning',
        })
    }
    ElMessageBox.confirm(
        `系统检测到共有【${row.length}】位人员需要进行信息提交，请确认是否现在提交?`,
        '信息',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info',
        }
    )
        .then(() => {
            const ids = row.map(item => item.idNumber)
            tableData.value = tableData.value.map(item =>{
                if(ids.includes(item.idNumber)){
                    item = {...item,reportStatus:'报送成功',authenticationStatus:'验证成功'}
                    return item;
                }
                return item
            })
            taxStore.setPersonCollectionList(tableData.value)
        })
        .catch(() => {

        })
}
const feedbackData = ref([])
const feedbackShow = ref(false)
const getFeedback = () =>{
    const row = getSelectionRows();
    if(row.length == 0){
        return ElMessage({
            message: '您还没有选中需要获取反馈的人员',
            type: 'warning',
        })
    }
    const rList = getReportList();
    if(rList.length == 0){
        return ElMessage({
            message: '获取反馈失败,请先确保所选姓名点击报送按钮后再进行操作',
            type: 'warning',
        })
    }
    feedbackData.value = [...row];
    feedbackData.value = feedbackData.value.map(item =>{
        item = {...item,reportStatus:'报送成功'}
        return item;
    })
    const ids = feedbackData.value.map(item => item.idNumber);
    tableData.value = tableData.value.map(item =>{
        if(ids.includes(item.idNumber)){
            item = {...item,reportStatus:'报送成功',authenticationStatus:'验证成功'}
            return item;
        }
        return item
    })
    feedbackShow.value = true;
    taxStore.setPersonCollectionList(tableData.value)
}
onUnmounted(()=>{
  sessionStorage.setItem('taxPersonCommonList' + route.query.id, JSON.stringify(tableData.value))
  taxStore.setPersonCollectionList(tableData.value)
})

const uploadPersonUrl = ref(import.meta.env.VITE_APP_BASE_API + "/system/exam/importPersonInfo"); // 导入人员接口地址
const headers = ref({Authorization: "Bearer " + getToken()});

function beforeUp(file) {
  if (file.size > 10 * 1024  * 1024) {
    ElMessage.error('文件太大，最大支持10M!')
    return false
  }
  const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  if (!['xls', 'xlsx', 'XLS', 'XLSX'].includes(suffix)) {
    ElMessage.error('上传文件类型错误!')
    return false
  }
  return true
}

let loadingInstance

function onStart() {
  loadingInstance = ElLoading.service({
    text: "正在上传，请稍候",
    background: "rgba(0, 0, 0, 0.5)",
    body: true,
  })
}


function handleSu(resp) {
  loadingInstance.close()
  if (resp.code !== 200) {
    ElMessage.error('导入失败，请重试')
    return
  }
  // 上传成功
  const importData = (resp.data || []).filter(f =>
      !tableData.value.some(s => s.idNumber == f.idNumber) &&
      answer.value.some(s => s.idNumber == f.idNumber)
  ).map(m => ({
    ...m,
    reportStatus: '验证中',
    isEmployees: '是',
  }))
  tableData.value = tableData.value.concat(importData)
  ElMessage.info(`成功导入了${importData.length}条数据`)
}

function onError() {
  loadingInstance.close()
}

const maxHeight = ref(220)
maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 430)


onMounted(() => {
})

useOnResize(() => {
  maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 430)
})
</script>

<template>
    <div class="wrap">
        <div class="tip">
            <p><el-icon color="#409efc" size="18"><WarningFilled /></el-icon></p>
            <p>1.请如实墳写纳税人的身份信息等基础资料，避免因信息不实对后续其他业务的办理造成影响</p>
            <p>2.只有“报送成功”的纳税人才能进行扣缴申报操作，请及时进行【报送】</p>
            <p>3.更正往期申报表，无需调整人员状态</p>
        </div>
        <div class="type">
            <span class="title">2024年01月 人员信息采集</span>
            <div class="total">
                <span>总人数:{{tableData.length}}人</span>
                <span>本月新增:0人</span>
                <span>本月减少:0人</span>
            </div>
        </div>
        <div>
            <el-space :size="14" >
                <el-button type="primary" @click="showAdd = true">添加</el-button>

              <el-dropdown>
                <el-button type="primary">
                  导入<el-icon style="margin-left: 3px;"><ArrowDown /></el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item>
                      <el-upload
                          :action="uploadPersonUrl"
                          :limit="999"
                          :show-file-list="false"
                          accept=".xlsx, .xls"
                          :headers="headers"
                          name="file"
                          :before-upload="beforeUp"
                          :on-success="handleSu"
                          :on-progress="onStart"
                          :on-error="onError"
                      >
                        <el-link :underline="false">导入文件</el-link>
                      </el-upload>

                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link :underline="false"
                               href="https://renhe-platform-prod.oss-cn-shanghai.aliyuncs.com/%E4%BA%BA%E5%91%98%E4%BF%A1%E6%81%AF%E9%87%87%E9%9B%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls"
                      >下载模板</el-link>
                      </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

                <el-button type="primary" @click="reportHandler">报送</el-button>
                <!-- <el-button type="primary" @click="getFeedback">获取反馈</el-button> -->
                <el-button type="primary" @click="clearList">清空重做</el-button>
            </el-space>
        </div>
        <div class="tabs">
            <el-tabs v-model="activeName" class="demo-tabs"  @tab-change="handleClick">
                <el-tab-pane label="境内人员" name="within"></el-tab-pane>
                <el-tab-pane label="境外人员" name="outer" disabled></el-tab-pane>
            </el-tabs>
        </div>
        <el-table
            :data="tableData"
            :max-height="maxHeight"
            ref="tableRef" style="width: 100%" border>
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="employeesNo" label="工号"  />
            <el-table-column prop="name" label="姓名" />
            <el-table-column prop="certificateType" label="证件类型" />
            <el-table-column prop="idNumber" label="证件号码" />
            <el-table-column prop="sex" label="性别" />
            <el-table-column prop="status" label="人员状态" />
            <el-table-column prop="reportStatus" label="报送状态" />
            <el-table-column prop="authenticationStatus" label="身份验证状态" />
            <el-table-column prop="phone" label="手机号码" />
            <el-table-column prop="situations" label="是否残疾" >
                <template #default="{ row }">
                   <span v-if="row.situations">{{ row.situations.includes('残疾')?'是':'否' }}</span>
                   <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="situations" label="是否烈属" >
                <template #default="{ row }">
                   <span v-if="row.situations">{{ row.situations.includes('烈属')?'是':'否' }}</span>
                   <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column prop="situations" label="是否孤老" >
                <template #default="{ row }">
                   <span v-if="row.situations">{{ row.situations.includes('孤老')?'是':'否' }}</span>
                   <span v-else>否</span>
                </template>
            </el-table-column>

            <el-table-column prop="employeeType" label="任职受雇从业类型" min-width="100"/>
            <el-table-column prop="isEmployees" label="是否雇员" />

            <el-table-column prop="nationality" label="国籍（地区）" min-width="100"/>
            <el-table-column prop="remark" label="备注" />
        </el-table>
        <add v-model:show="showAdd" @confirm="confirmAdd"/>
        <el-dialog
            v-model="feedbackShow"
            title="身份验证成功"
            width="500"
        >
            <el-table :data="feedbackData"  style="width: 100%" border>
                <el-table-column prop="name" label="姓名" />
                <el-table-column prop="idNumber" label="证件号码" />
                <el-table-column prop="certificateType" label="证件类型" />
                <el-table-column prop="reportStatus" label="报送状态" />
            </el-table>
            <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="feedbackShow = false">
                    确定
                </el-button>
            </div>
        </template>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.wrap{
    width:100%;
    height: 100%;
    :deep(.el-table){
        --el-table-header-bg-color:#f8f9fa;
    }
    .tip{
            width: 100%;
            display: flex;
            flex-direction: column;
            background: #f0f3f6;
            color: #666;
            padding: 8px;
            box-sizing: border-box;
            font-size: 14px;
            p{
                margin-bottom: 6px;
            }
    }
    .type{
        height: 60px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .title{
            height: 20px;
            border-left: 4px solid var(--el-color-primary);
            box-sizing: border-box;
            line-height: 20px;
            text-indent: 12px;
            font-weight: bold;
        }
        .total{
            margin-left: 50px;
            span{
                color: #999;
                font-size: 13px;
                margin: 0 12px;
            }
        }
    }
}
</style>
